import { render, staticRenderFns } from "./SkeletonHeader.vue?vue&type=template&id=c258d23e&"
import script from "./SkeletonHeader.vue?vue&type=script&lang=js&"
export * from "./SkeletonHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports